import { string, object } from 'yup'

export const CategoryFormValidator = object().shape({
    name: string().required('Category title is required').max(50),
})
